import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-noticeB",
  "use": "icon-noticeB-usage",
  "viewBox": "0 0 1408 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1408 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-noticeB\"><defs><style type=\"text/css\"></style></defs><path d=\"M64 798.848V896a64 64 0 0 0 64 64h1152a64 64 0 0 0 64-64v-97.152a31.872 31.872 0 0 1-19.52-5.76L888.32 486.72l-165.952 116.544a32 32 0 0 1-36.8 0L519.616 486.72l-436.096 306.304a31.872 31.872 0 0 1-19.52 5.76z m0-70.272l400-280.96L64 166.72v561.856z m1280 0V166.72l-399.936 280.96L1344 728.576z m-7.936-631.424A64 64 0 0 0 1280 64H128a64 64 0 0 0-56.064 33.152c4.032 0.896 8 2.56 11.648 5.12L704 538.112l620.48-435.84a31.872 31.872 0 0 1 11.584-5.12zM128 0h1152a128 128 0 0 1 128 128v768a128 128 0 0 1-128 128H128a128 128 0 0 1-128-128V128a128 128 0 0 1 128-128z\" fill=\"#1296db\" p-id=\"5123\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/noticeB.svg
// module id = MMv1
// module chunks = 81